import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireSeller = false, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    if (requireAdmin || location.pathname.startsWith('/admin')) {
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    if (requireSeller || location.pathname.startsWith('/seller')) {
      return <Navigate to="/seller/login" state={{ from: location }} replace />;
    }
    return <Navigate to="/buyer/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/buyer" replace />;
  }

  if (requireSeller && user.role !== 'seller' && user.role !== 'both' && user.role !== 'admin') {
    return <Navigate to="/buyer" replace />;
  }

  return children;
};

export default ProtectedRoute;
